export default __webpack_public_path__ + "static/media/spin_icon.2d4baf9d.png";